import { z } from "zod"

import { ApplicableToEnum, IncludeWithEnum, TransportationModeEnum } from "@/graphql/codegen/graphql"

export const InstructionFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Instruction name is required" })
    .max(64, { message: "Instruction name must be less than 64 characters" }),
  description: z
    .string()
    .min(1, { message: "Instruction text is required" })
    .max(2078, { message: "Instruction text must be less than 2078 characters" }),
  isHazard: z.boolean().default(false),
  applicableTo: z.array(z.nativeEnum(ApplicableToEnum)).min(1, "Please select at least one applicable option"),
  transportationMode: z
    .array(z.nativeEnum(TransportationModeEnum))
    .min(1, "Please select at least one transportation mode"),
  includeWith: z.array(z.nativeEnum(IncludeWithEnum)).min(1, "Please select at least one inclusion option"),
  image: z.optional(z.instanceof(File)),
})
